function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import styles from './ScheduledAnnouncement.module.scss';
import Logo from '../icons/logos/Nightbot';
import classNames from 'classnames';
import { Text, Title } from '@mantine/core';
import { AnimatePresence, motion, useInView } from 'framer-motion';
import useIntlMemo from '@/hooks/useIntlMemo';
import { useDebounce } from 'use-debounce';
import { LordIconSizes } from '@/types/client';
import Bell from '../icons/lord/Bell';
function NightbotReply(_param) {
    var announcement = _param.announcement, shouldPlay = _param.shouldPlay, props = _object_without_properties(_param, [
        "announcement",
        "shouldPlay"
    ]);
    var ref = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(false), 2), ready = _React_useState[0], setReady = _React_useState[1];
    React.useEffect(function() {
        var currentRef = ref.current;
        if ((currentRef === null || currentRef === void 0 ? void 0 : currentRef.playFromBeginning) == null || !ready || !shouldPlay) {
            return;
        }
        var timeout = setTimeout(function() {
            return currentRef.playFromBeginning();
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        ref,
        ready,
        shouldPlay
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: styles.chatterContainer
    }, props), {
        children: /*#__PURE__*/ _jsxs(motion.div, {
            transition: {
                duration: 0.1
            },
            className: styles.chatter,
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.logoContainer,
                    children: /*#__PURE__*/ _jsx(Logo, {
                        className: styles.logo
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.announcementInfo,
                    children: [
                        /*#__PURE__*/ _jsx(Title, {
                            order: 4,
                            children: "Nightbot"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            size: "xs",
                            className: styles.message,
                            children: announcement.announcement
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.chatterScanIcon,
                    children: /*#__PURE__*/ _jsx(Bell, {
                        ref: ref,
                        onReady: function() {
                            return setReady(true);
                        },
                        size: LordIconSizes.SMALL
                    })
                })
            ]
        })
    }));
}
var INTERVAL = 3000;
var SHIFT = 10;
export default function ScheduledAnnouncementPanel(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var _React_useState = _sliced_to_array(React.useState(0), 2), announcementCount = _React_useState[0], setAnnouncementCount = _React_useState[1];
    var ref = useRef(null);
    var inView = useInView(ref);
    var _useDebounce = _sliced_to_array(useDebounce(inView, 500), 1), debouncedInView = _useDebounce[0];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), isVisible = _React_useState1[0], setIsVisible = _React_useState1[1];
    var nightbotAnnouncements = useIntlMemo(function(intl) {
        return [
            {
                id: 'discord-announcement',
                announcement: intl.formatMessage({
                    id: "nW+4Ky",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Join our Discord community to share support!"
                        }
                    ]
                })
            },
            {
                id: 'youtube-announcement',
                announcement: intl.formatMessage({
                    id: "HjnHmq",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Check out our YouTube channel for tutorials!"
                        }
                    ]
                })
            },
            {
                id: 'website-announcement',
                announcement: intl.formatMessage({
                    id: "Lebyhv",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Visit our website for more information!"
                        }
                    ]
                })
            },
            {
                id: 'instagram-announcement',
                announcement: intl.formatMessage({
                    id: "DHHJ7V",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Follow us on Instagram for behind-the-scenes!"
                        }
                    ]
                })
            },
            {
                id: 'facebook-announcement',
                announcement: intl.formatMessage({
                    id: "5Eb/TO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Like us on Facebook for news and updates!"
                        }
                    ]
                })
            },
            {
                id: 'tiktok-announcement',
                announcement: intl.formatMessage({
                    id: "nZA95n",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Follow us on TikTok for fun clips!"
                        }
                    ]
                })
            }
        ];
    }, []);
    if (nightbotAnnouncements.length < 3) {
        throw new Error('Not enough announcements to display');
    }
    var currentAnnouncements = React.useMemo(function() {
        return [
            nightbotAnnouncements[announcementCount % nightbotAnnouncements.length],
            nightbotAnnouncements[(announcementCount + 1) % nightbotAnnouncements.length],
            nightbotAnnouncements[(announcementCount + 2) % nightbotAnnouncements.length]
        ];
    }, [
        announcementCount,
        nightbotAnnouncements
    ]);
    React.useEffect(function() {
        if (!debouncedInView || !isVisible) {
            return;
        }
        setAnnouncementCount(function(prev) {
            return prev + 1;
        });
        var interval = setInterval(function() {
            return setAnnouncementCount(function(prev) {
                return prev + 1;
            });
        }, INTERVAL);
        return function() {
            return clearInterval(interval);
        };
    }, [
        debouncedInView,
        isVisible
    ]);
    React.useEffect(function() {
        var handleVisibilityChange = function() {
            return setIsVisible(document.visibilityState === 'visible');
        };
        handleVisibilityChange();
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function() {
            return document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: ref,
        className: classNames(styles.announcementPanel, className)
    }, props), {
        children: /*#__PURE__*/ _jsx(AnimatePresence, {
            mode: "popLayout",
            initial: false,
            children: currentAnnouncements.map(function(announcement, index) {
                var intialScale = 1 - index * 0.05;
                var initialFilter = "brightness(".concat(1 - index * 0.1, ")");
                var zIndex = currentAnnouncements.length - index;
                var shouldPlay = index === 0;
                return /*#__PURE__*/ _jsx(motion.div, {
                    layout: true,
                    style: {
                        position: 'absolute',
                        width: '100%'
                    },
                    initial: {
                        opacity: 0,
                        filter: initialFilter,
                        scale: intialScale,
                        zIndex: zIndex
                    },
                    animate: {
                        opacity: 1,
                        filter: initialFilter,
                        scale: intialScale,
                        zIndex: zIndex,
                        y: index * SHIFT
                    },
                    exit: {
                        opacity: 0,
                        zIndex: currentAnnouncements.length + 10,
                        y: -SHIFT,
                        transition: {
                            duration: 0.5,
                            delay: 0
                        }
                    },
                    transition: {
                        duration: 1,
                        ease: 'backInOut'
                    },
                    children: /*#__PURE__*/ _jsx(NightbotReply, {
                        announcement: announcement,
                        shouldPlay: shouldPlay
                    })
                }, announcement.id);
            })
        })
    }));
}
